import { Box, Heading, useColorModeValue, Stack, StackDivider, Text } from '@chakra-ui/react';
import { TooltipProps } from 'recharts';
import { MarketModel } from 'models/Market/Market';

interface MarketVolumeTooltipProps extends TooltipProps<number, string> {
	data?: MarketModel[];
}

const MarketVolumeTooltip = ({ active, payload, label }: MarketVolumeTooltipProps) => {
	const bgColor = useColorModeValue('white', 'navy.800');
	const textColor = useColorModeValue('secondaryGray.900', 'white');
	const textColorSecondary = useColorModeValue('secondaryGray.600', 'white');
	const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');

	if (!active || !payload || !payload.length) {
		return null;
	}

	const data = payload[0].payload;

	return (
		<Box
			bg={bgColor}
			p={4}
			borderRadius="lg"
			boxShadow="lg"
			border="1px solid"
			borderColor={borderColor}
		>
			<Stack spacing={3}>
				<Box>
					<Text color={textColorSecondary} fontSize="sm">
						Date
					</Text>
					<Heading size="sm" color={textColor}>
						{label}
					</Heading>
				</Box>
				<StackDivider />
				<Box>
					<Text color={textColorSecondary} fontSize="sm">
						Volume
					</Text>
					<Heading size="sm" color={textColor}>
						{data.value}
					</Heading>
				</Box>
				{data.percentage && (
					<Box>
						<Text color={textColorSecondary} fontSize="sm">
							Percentage
						</Text>
						<Heading size="sm" color={textColor}>
							{data.percentage}%
						</Heading>
					</Box>
				)}
			</Stack>
		</Box>
	);
};

export default MarketVolumeTooltip;
